import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography
} from '@mui/material';

// Components
import ApplicationHelpPanel from './ApplicationHelpPanel';
import ApplicationOverviewPanel from './ApplicationOverviewPanel';
import QuestionsPanel from './QuestionsPanel';
import LaunchPanel from './LaunchPanel';

interface ApplicationsProps {
  campaignId: string;
  organizationId: string;
}

const Applications: React.FC<ApplicationsProps> = ({ campaignId, organizationId }) => {
  // Auto-save indicator
  const [saveStatus, setSaveStatus] = useState<'saved' | 'saving' | null>(null);
  // Track if campaign is launched
  const [isLaunched, setIsLaunched] = useState<boolean>(false);

  // Auto-save function
  const saveApplicationData = () => {
    console.log('Saving application data...once its implemented');
    setSaveStatus('saving');
    setTimeout(() => setSaveStatus('saved'), 1000);
  };

  // Check if campaign is launched
  useEffect(() => {
    // This would be replaced by an actual API call to check campaign status
    const checkCampaignStatus = async () => {
      try {
        // Mock API call - in a real app, you would fetch from API
        // const response = await api.getCampaign(campaignId);
        // setIsLaunched(response.isLaunched);
        setIsLaunched(false); // Default to not launched
      } catch (error) {
        console.error('Error fetching campaign status:', error);
      }
    };
    
    checkCampaignStatus();
  }, [campaignId]);

  return (
    <Box sx={{ width: '100%' }}>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h4">Applications</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {saveStatus && (
              <Typography
                variant="body2"
                sx={{
                  mr: 2,
                  color: saveStatus === 'saved' ? 'success.main' : 'text.secondary',
                  fontStyle: 'italic'
                }}
              >
                {saveStatus === 'saving' ? 'Saving...' : 'Changes saved'}
              </Typography>
            )}
          </Box>
        </Box>
        <ApplicationHelpPanel />
        <ApplicationOverviewPanel
          campaignId={campaignId}
          organizationId={organizationId}
        />
        <QuestionsPanel
          campaignId={campaignId}
          organizationId={organizationId}
        />
      </Box>
    </Box>
  );
};







export default Applications;